const Backbone = require('backbone');
var RecommendedOptionFinishModel = Backbone.Model.extend({
	defaults: {
		selected: false,
		manuallySelected: false
	}
});

module.exports = RecommendedOptionFinishModel;
